import React, { useState, Fragment } from 'react'
import { IStudentSurveyQuestionTypeProps } from '../StudentSurveyQuestion'
import './RatingQuestion.less'

const RatingQuestion = ({
  question,
  setAnswer,
  answer
}: IStudentSurveyQuestionTypeProps) => {
  const [hoveredOption, setHoveredOption] = useState<number | null>(null)
  const options = question.content?.options || []

  const getSelectedOption = () => {
    return answer
      ? [...options].reverse().findIndex((option) => option.id === answer) + 1
      : null
  }
  const getQuestionClass = (index) => {
    // @ts-expect-error 9/11/2020
    return index <= (hoveredOption ? hoveredOption : getSelectedOption())
      ? 'RatingQuestion__item--hovered'
      : ''
  }

  const getRealKey = (key) => key - options.length + 11

  return (
    <div className="RatingQuestion__wrapper">
      <div
        className="RatingQuestion"
        role="radiogroup"
        aria-label={question.title}
      >
        {[...options].reverse().map((option, index) => {
          const realKey = getRealKey(index)
          const selected = option.id === answer

          return (
            <Fragment key={option.id}>
              <input
                id={option.id}
                className="RatingQuestion__input"
                type="radio"
                role="radio"
                aria-checked={selected}
                tabIndex={(!answer && index === 0) || selected ? 0 : -1}
                name={question.title}
                value={option.id}
                onChange={() => {
                  setAnswer(option.id)
                }}
              />
              <label
                htmlFor={option.id}
                className={`RatingQuestion__item ${
                  hoveredOption || getSelectedOption()
                    ? getQuestionClass(index + 1)
                    : ''
                } RatingQuestion__item--${realKey}`}
                onMouseOver={() => setHoveredOption(index + 1)}
                onMouseLeave={() => setHoveredOption(null)}
                aria-label={option.label}
              >
                <div className="RatingQuestion__item__value">
                  {option.label}
                </div>
              </label>
            </Fragment>
          )
        })}
      </div>

      <div className="RatingQuestion__labels">
        <div className="RatingQuestion__label RatingQuestion__label--left">
          {options[options.length - 1].label}
        </div>
        <div className="RatingQuestion__label RatingQuestion__label--right">
          {options[0].label}
        </div>
      </div>
    </div>
  )
}

export default RatingQuestion
